// extracted by mini-css-extract-plugin
export default {"flag":"Flag__flag-V4mD"};